/**
 * @file dictionary.icon.tsx
 * @description Компонент для отображения иконки части компонента @components/ui/data/dictionary.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 */

import { IIconProps } from '@src/types';

export const DictionaryIcon = ({ size = '1.2703vmin', ...props }: IIconProps) => {
    return (
        <span className="block icons--Icon icons--Icon_size_xs icons--Icon_color_mono IconClose Button-Icon" {...props}>
            <svg
                className="icons--Icon-Svg"
                width={size}
                height={size}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path d="M0.999381 1.00039L4.99938 1.00039L4.99938 2.00039H1.99938L1.99938 10.0004H9.99938V7.00039L10.9994 7.00039L10.9994 11.0004H0.999381L0.999381 1.00039Z" />
                    <path d="M11.0094 1.00015L11.0094 5.9499L6.05968 1.00015L11.0094 1.00015Z" />
                    <path d="M8.18102 3.12149L8.88812 3.82859L5.71625 7.00064L5.00915 6.29353L8.18102 3.12149Z" />
                </g>
                <defs>
                    <clipPath id="clip0_1504_49388">
                        <rect width={size} height={size} fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
};
